<script setup>
import {ref} from "vue";
const {name, image} = defineProps(['name', 'image']);
const emit = defineEmits(['input', 'change']);
const model = defineModel();
const input = ref(null);
const file = ref(image);
let error = ref(null);

const rules = {size: 100, height: 500, width: 500, types: ['image/jpeg', 'image/jpg', 'image/png']};

function handleChange(e) {
    const files = Array.from( e.target.files );
    const firstFile = files[0];

    if ( !firstFile ) {
        return;
    }

    const blobFile = URL.createObjectURL( firstFile );

    if ( rules.size && !( ( firstFile.size / 1000 ) <= rules.size ) ) {
        error.value = 'Fichier trop lourd';
        return;
    }

    if ( rules.types && ! rules.types.includes( firstFile.type ) ) {
        error.value = 'Format non conforme';
        return;
    }

    const img = new Image();
    img.src = blobFile;
    img.onload = () => {
        if ( rules.width && rules.height && rules.width <= img.width && rules.height <= img.height ) {
            error.value = 'Dimensions non conforme';
        } else {
            file.value = blobFile;
            error.value = null;
            emit('input', firstFile );
            emit('change', firstFile );
            model.value = firstFile;
        }
    };
}

</script>

<template>
    <div class="flex flex-row gap-x-5">
        <div>
            <div class="h-36 w-36 bg-white rounded-full">
                <img :src="file" alt="Votre photo de profil" class="block h-36 w-36 border border-white/10 rounded-full" v-if="file">
            </div>
        </div>

        <div>
            <button class="button-invert p-2 mb-5" type="button" @click="input.click()" title="Choisir une photo" aria-label="Choisir une photo">Choisir une photo</button>
            <div class="text-white text-xs">
                <slot></slot>
            </div>
            <div class="text-red-500 text-xs" v-if="error" v-html="error"></div>

            <input type="file" :name="name" ref="input" class="hidden" @change="handleChange" :accept="rules.types.join(',')">
        </div>
    </div>
</template>